import { Component, Input, OnDestroy, OnInit,  ViewChild} from '@angular/core';
import * as fromFeature from '../../my-features';
import { Location } from '@angular/common';
import { SelectItem } from 'primeng/api';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';
import { Observable, Subject, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import {CryptoService} from '../../services/crypto.service';
import { AccountService } from "../../services/account.service";
import {
  batteryTestStatus,
  PackageList,
  timeZoneOption,
  unitOption,
  updateInfoType,
  SourceType,
  ReLoadDeviceUpsControlSec,
  upsControlType,
  AuthOtpType, 
  AuthOtpDeviceType, 
  CheckAuthOtpErrMsg
} from '../../shareModel';
import { EventsParams, FilterParams } from '../../models/events';
import { DevicesInfoData } from '../../models/devices';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isODM } from '../../../environments/environment';
import { Confirm_button } from '../../../environments/environment';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import * as fromMyfeatures from '../../my-features';
import { BatteryTestParams } from '../../my-features/battery-test/battery-test.model';
import { combineLatest } from 'rxjs';
import { concatMap, distinctUntilChanged, first, takeUntil, withLatestFrom } from 'rxjs/operators';
import {
  BatteryReplacement,
  BtyReplacementParams
} from '../../my-features/battery-replacement/battery-replacement.model';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { PreferenceService } from '../../services/preference.service';
import { DialogComponent } from '../../../app/dialog/dialog.component';
import { User } from '../../models/user';

@Component({
  standalone: false,
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit, OnDestroy {
  eventLogs_cols: any[] = [
    { field: 'status', header: TRANSLATE('Status'), width: '100', class: 'col-nowrap text-center', disabled: false },
    { field: 'time', header: TRANSLATE('Time'), width: '180', class: 'col-nowrap', disabled: false },
    { field: 'timezoneLabel', header: TRANSLATE('Time Zone'), width: '120', class: 'hidden-sm', disabled: false },
    { field: 'desc', header: TRANSLATE('Description'), width: '100%', class: 'desc', disabled: false },
  ];
  BRBDexpireNotify = true;
  hasErrorCode = false;
  errorCodeBg = '#d51f35'; // warning: #fdc503; critical: #d51f35;
  timeOptions: SelectItem[] = [ ];
  batteryLifeOptions: SelectItem[] = [
    { label: '1 Year', value: 12 },
    { label: '2 Year', value: 24 },
    { label: '3 Year', value: 36 },
  ];
  batteryTestWaitingTime = 0;
  powerMaster = isODM;
  Confirm_button = Confirm_button;
  loading = true;
  timezoneOptions: SelectItem[] = timeZoneOption;
  unitOptions: SelectItem[] = unitOption;
  display = false;
  displayBHI = false;
  confirm_BHI = false;
  dateRange = 'all';
  pageContentInfo: any = {};
  pageContentStatus: any = {};
  sn: string;
  reportingRange: any = {};
  curDate = new Date();
  eventLogs$: Observable<any>;
  RangeParam: EventsParams = {
    otp: '',
    startDate: new Date(this.curDate.getTime() - 24 * 60 * 60 * 1000 * 3),
    endDate: new Date()
  };
  eventParams: FilterParams = {
    deviceName: '',
    status: -1,
    sn: '',
    type: 'device'
  };
  UpdateInfoParam = {} as UpdateInfoModel;
  private componentDestroyed = new Subject();
  deviceDetails$: Observable<any>;
  timezoneErrors = false;
  indexNum = 0;
  energyRangeStart: Date;
  energyRangeEnd: Date;
  energyInfoFeature: Boolean;
  batteryTestFeature: Boolean;
  isTrial: Boolean = true;
  batteryLife: Boolean = false;
  localTimeZone = new Date().getTimezoneOffset() / 60;
  deviceOriginalSetting = {
    region: 0,
    deviceDescription: '',
    name: '',
    batteryReplacementInfo: {} as BatteryReplacement
  };
  batteryTestResult = {
    blockUI: false,
    status: batteryTestStatus[3],
    date: null
  };
  batteryReplacementInfo: BatteryReplacement = {
    expires: false
  };
  btyTimeCycling: any;
  OutputStatusStr = TRANSLATE('Output Status');
  RBRDChange = false;
  BR_Date: any;
  private pendingBRDateEpoch: number | null = null;
  private pendingBRDateFormat: Date | null = null;
  BtyReplaceCheck = false;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  isBHIActivated = false;
  isFirstCriticalUpload = true; // Critical Upload 避免重複發送通知
  outletNamingDialog = false;
  displayUPSControl: boolean = false;
  enableUpsCtrl: boolean = false;
  agreeUpsControl: boolean = false;
  intervalId: any = null;
  intervalCnt = 0;
  runExecute: boolean = false;
  buttonStatusFromExecType: number | null = null; // 執行完成後鎖定 buttonStatus，防止 device detail refresh 觸發的 reloadUpsControl 回傳舊值時覆蓋

  outletNamingDialogInput: {
    outlet1: string;
    outlet2: string;
    outlet3: string;
    outlet4: string;
    outlet5: string;
    outlet6: string;
    outlet7: string;
    outlet8: string;
    outlet9: string;
    outlet10: string;
    outlet11: string;
    outlet12: string;
    outlet13: string;
    outlet14: string;
    outlet15: string;
    outlet16: string;
  };

  regionDic = {};
  isMsp = false;
  disableBHI = false;
  disableOutletSave = false;
  disableBattery = false;
  disableSetting = false;
  hideBHI = false;
  mspSelectedRegionId = [];
  mspCompanyOptionsDic = {};
  mspCompanyOptions = [];
  UserParam = {} as User;
  mspMemberAuthorityDic = {};
  device_regionId: number;
  // battery_replace_count = 0;
  NotMspDeviceInfoIsRead = false;
  subDeviceDetail = [];
  SourceType = SourceType;
  upsControl: Boolean = true;
  buttonStatus: number;
  otpid: number;
  twoFactorAuthentication: boolean = false;
  message: string;
  allowUpsContrlAccessType: string;
  confrimOTPParam = {
    otp: "",
    authId: 0,
    authType: AuthOtpType.TurnOn,
    authOtp: this.accountService.GetAuthOtp,
  };
  upsColudStatusParam: { 
    otp: string; 
    dcode: number; 
    OutSta?: number; 
    CloudFlag?: number; 
    ExecType?: number; 
    ExecStatus?: number } = {
    otp: "",
    dcode: 0,
  }

  constructor(private translateService: TranslateService, private route: ActivatedRoute, private messageService: MessageService,
    private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>, private location: Location,
    public preferenceService: PreferenceService, private cryptoService: CryptoService, private accountService: AccountService) {
    this.sn = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('sn'));
    this.eventParams = {
      ...this.eventParams,
      sn: this.sn,
    };
    // this.store.dispatch(new fromStore.GetEventAction(this.RangeParam));
    // this.store.dispatch(new fromStore.GetEventFilterParams(this.eventParams));
    this.store.dispatch(new fromStore.GetDevicesDetails(this.sn));
    // Get Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.EditDeviceInfo) {
          if (res.isSaved) {
            if (this.pendingBRDateEpoch !== null) {
              this.batteryReplacementInfo = {
                ...this.batteryReplacementInfo,
                BR_Date: this.pendingBRDateEpoch,
                BR_Date_Format: this.pendingBRDateFormat,
              };
              this.deviceOriginalSetting.batteryReplacementInfo = { ...this.batteryReplacementInfo };
              this.BR_Date = this.pendingBRDateFormat;
            }
            const UserParam = {regionIds: this.RangeParam.RegionIds} as User;
            this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
            this.store.dispatch(new fromStore.GetDeviceInfoAction({regionIds: this.RangeParam.RegionIds}));
            this.store.dispatch(new fromStore.GetDevicesDetails(this.sn));
            this.store.dispatch(new fromFeature.GetBatteryReplacements({
              dcode: this.pageContentStatus.dcode,
            } as BtyReplacementParams));
            clearTimeout(this.btyTimeCycling);
            this.messageService.add({ severity: 'success', summary: this.translateService.instant('Update Success') });
          } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
            this.messageService.add({ severity: 'error', summary: this.translateService.instant('Update Fail') });
          }
        } else if (res.type === updateInfoType.BatteryTestFail) {
          this.messageService.add(({ severity: 'error', summary: this.translateService.instant('Battery test was failed.') }));
        } else if (res.type === updateInfoType.UpdateDeviceSetting) {
          if (res.isSaved) {
            this.messageService.add(({ severity: 'success', summary: res.msg }));
          } else {
            this.messageService.add(({ severity: 'error', summary: this.translateService.instant('Update device setting failed.') }));
          }
        }
        // this.ngxService.stop();
      }
    });

    // Get Battery Test Status
    this.store.select(fromStore.getBatteryTestStatus).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // BatteryTest非同步問題 : deviceInfo有可能讀取較慢 所以改為確認SN是否相同
      if (this.sn === res.entities.SN) {
        if (res && res.isLoaded && !res.isLoading) {
          this.batteryTestResult.blockUI = res.entities.code === 1;
          this.batteryTestResult.date = res.entities.code === 3 ? null : res.entities.date;
          this.batteryTestResult.status = batteryTestStatus.hasOwnProperty(res.entities.code) ? batteryTestStatus[res.entities.code] : '--';
          if (res.entities.code === 1) { // 2025-03-06 kyrie:避免離開頁面後仍一直呼叫GetBatteryTest 所以從effect拉到此處處理
            this.store.dispatch(new fromMyfeatures.GetDelayBatteryTestStatuss({upsSn: this.sn}));
          }
        }
      }
    });

    // Get Device Details
    this.deviceDetails$ = this.store.select(fromStore.getDeviceDetails);
    combineLatest(this.store.select(fromStore.getDeviceDetails), this.store.select(fromStore.getSingleDeviceStatuses(this.sn)), this.store.select(fromStore.getPreferences))
    .pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)))
    .pipe(takeUntil(this.componentDestroyed)).subscribe(([resDevice, resStatus, resPreferences]) => {
      if (resDevice) {
        this.isTrial = resDevice.TrialRemainDay > 0;
        if (resStatus) {
          this.isBHIActivated = resDevice.BHI_Enable;
          this.device_regionId = resStatus.regionId;
          this.displayMspAuth_fun();
          if (this.isFirstCriticalUpload && resDevice.is_critical_update && !this.pageContentStatus.is_shared) {
            this.childDialog.isCriticalUpload();
            this.isFirstCriticalUpload = false;
          }
          this.pageContentStatus.dcode = Number(resStatus.dcode);
          this.pageContentStatus.Brand = resStatus.Brand;
          this.pageContentStatus.name = resStatus.name;
          this.pageContentStatus.desc = resStatus.desc;
          this.pageContentStatus.icon = resStatus.icon;
          this.pageContentStatus.region = resStatus.timeZone;
          this.pageContentStatus.deviceDescription = resStatus.deviceDescription;
          this.pageContentStatus.image = resStatus.image;
          this.pageContentStatus.status = resStatus.status;
          this.pageContentStatus.gId = resStatus.gId;
          this.pageContentStatus.hardwarefault = resStatus.hardwarefault;
          this.pageContentStatus.is_shared = resStatus.is_shared;
          this.pageContentStatus.type = resStatus.type;
          this.pageContentStatus.subtype = resStatus.subtype;
          this.pageContentStatus.sourcetype = resStatus.SourceType;
          this.pageContentStatus.DeviceIP = resStatus.DeviceIP;

          this.deviceOriginalSetting.name = resStatus.name;
          this.deviceOriginalSetting.region = resStatus.timeZone;
          this.deviceOriginalSetting.deviceDescription = resStatus.deviceDescription;
          this.hideBHI = resStatus.hideBHI;
          this.subDeviceDetail = resDevice.subDevice;
          this.hasErrorCode = true;
        }
        if (resDevice !== undefined && resDevice.device_setting !== undefined) {
          this.outletNamingDialogInput = {
            outlet1: resDevice.device_setting.Outlet1 !== undefined ? resDevice.device_setting.Outlet1 : '',
            outlet2: resDevice.device_setting.Outlet2 !== undefined ? resDevice.device_setting.Outlet2 : '',
            outlet3: resDevice.device_setting.Outlet3 !== undefined ? resDevice.device_setting.Outlet3 : '',
            outlet4: resDevice.device_setting.Outlet4 !== undefined ? resDevice.device_setting.Outlet4 : '',
            outlet5: resDevice.device_setting.Outlet5 !== undefined ? resDevice.device_setting.Outlet5 : '',
            outlet6: resDevice.device_setting.Outlet6 !== undefined ? resDevice.device_setting.Outlet6 : '',
            outlet7: resDevice.device_setting.Outlet7 !== undefined ? resDevice.device_setting.Outlet7 : '',
            outlet8: resDevice.device_setting.Outlet8 !== undefined ? resDevice.device_setting.Outlet8 : '',
            outlet9: resDevice.device_setting.Outlet9 !== undefined ? resDevice.device_setting.Outlet9 : '',
            outlet10: resDevice.device_setting.Outlet10 !== undefined ? resDevice.device_setting.Outlet10 : '',
            outlet11: resDevice.device_setting.Outlet11 !== undefined ? resDevice.device_setting.Outlet11 : '',
            outlet12: resDevice.device_setting.Outlet12 !== undefined ? resDevice.device_setting.Outlet12 : '',
            outlet13: resDevice.device_setting.Outlet13 !== undefined ? resDevice.device_setting.Outlet13 : '',
            outlet14: resDevice.device_setting.Outlet14 !== undefined ? resDevice.device_setting.Outlet14 : '',
            outlet15: resDevice.device_setting.Outlet15 !== undefined ? resDevice.device_setting.Outlet15 : '',
            outlet16: resDevice.device_setting.Outlet16 !== undefined ? resDevice.device_setting.Outlet16 : '',
          };
        }
        this.displayUPSControl = false;
        if (resDevice !== undefined) {
          //ups control
          this.upsColudStatusParam = {
            ...this.upsColudStatusParam,
            dcode: Number(resDevice.dcode),
            ...(resDevice.OutStaNUM !== undefined && resDevice.OutStaNUM !== null ? { OutSta: resDevice.OutStaNUM } : {}),
            ...(resDevice.CloudFlag !== undefined && resDevice.CloudFlag !== null ? { CloudFlag: resDevice.CloudFlag } : {}),
          };
          if (resPreferences.Loaded && !resPreferences.Loading) {
            if (Object.keys(resPreferences.entities).length !== 0) {
              const preferences = resPreferences.entities;
              this.twoFactorAuthentication = Number(preferences.EnableOTP) === 1 ? true : false;
              if (this.isMsp) {
                if (this.mspMemberAuthorityDic[this.device_regionId] !== undefined &&
                  this.mspMemberAuthorityDic[this.device_regionId].ViewDevice === 1) {
                  if (this.mspMemberAuthorityDic[this.device_regionId].EditDevice === 1) {
                    this.reloadUpsControl();
                  }
                }
              } else {
                if (preferences.EnableUpsCtrl !== undefined && preferences.EnableUpsCtrl !== null && preferences.EnableUpsCtrl) {
                  this.upsControl = preferences.EnableUpsCtrl;
                  if (this.upsControl) {
                    this.reloadUpsControl();
                  }
                }
              }
            }
          }
        }
      }
    });
    // Get Event Log
    this.eventLogs$ = this.store.pipe(select(fromStore.getEventLogData));
    // Get Battery Replacement
    this.store.select(fromStore.getBatteryReplacementForDetails(this.sn)).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res && res.hasOwnProperty(this.pageContentStatus.dcode)) {
        const sourceInfo: BatteryReplacement = res[this.pageContentStatus.dcode];
        if (this.pendingBRDateEpoch !== null && sourceInfo?.BR_Date !== this.pendingBRDateEpoch) {
          // 儲存成功後先忽略舊值，避免 UI 被回寫成舊日期。
          return;
        }
        const info: BatteryReplacement = { ...sourceInfo };
        if (!this.display) {
          if (info.BR_Date != null) {
            info.BR_Date_Format = new Date(
              (this.localTimeZone + this.pageContentStatus.region) * 60 * 60 * 1000 + (info.BR_Date * 1000)
            );
          }
          this.batteryReplacementInfo = { ...info };
          this.deviceOriginalSetting.batteryReplacementInfo = { ...this.batteryReplacementInfo };
          clearTimeout(this.btyTimeCycling);
          if (this.pendingBRDateEpoch !== null && info.BR_Date === this.pendingBRDateEpoch) {
            this.pendingBRDateEpoch = null;
            this.pendingBRDateFormat = null;
          }
        }
      }
    });

    // Chang timeOptions Language after selection was changed.
    this.translateService.onLangChange.pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      this.readTimeOptions();
    });

    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== null) {
        let rangeParam = { ...this.RangeParam, RegionIds: null as any };
        if (res.isMsp && res.filterLoaded) {
          rangeParam = { ...rangeParam, RegionIds: res.selectedId };
          this.RangeParam = rangeParam;
          this.mspSelectedRegionId = res.selectedId;
          this.store.dispatch(new fromStore.GetEventFilterParams({ ...this.eventParams }));
          const UserParam = {regionIds: rangeParam.RegionIds} as User;
          this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
          this.store.dispatch(new fromStore.GetDeviceInfoAction({regionIds: rangeParam.RegionIds}));
        } else if (!res.isMsp && !this.NotMspDeviceInfoIsRead) {
          this.RangeParam = rangeParam;
          this.store.dispatch(new fromStore.GetEventFilterParams({ ...this.eventParams }));
          this.store.dispatch(new fromStore.GetDevicesStatusAction());
          this.store.dispatch(new fromStore.GetDeviceInfoAction());
          this.NotMspDeviceInfoIsRead = true;
        }
      }
    });

    combineLatest(this.store.select(fromStore.getDeviceDetails), this.store.select(fromStore.getMspRegionFilter))
    .pipe(takeUntil(this.componentDestroyed)).subscribe(([resDevice, resMsp]) => {
      if (resDevice && resMsp !== null) {
        let rangeParam = { ...this.RangeParam, dcode: resDevice.dcode };
        if (resMsp.isMsp && resMsp.filterLoaded) {
          rangeParam = { ...rangeParam, RegionIds: resMsp.selectedId };
          this.RangeParam = rangeParam;
          this.store.dispatch(new fromStore.GetEventAction({ ...rangeParam }));
        } else if (!resMsp.isMsp) {
          this.RangeParam = rangeParam;
          this.store.dispatch(new fromStore.GetEventAction({ ...rangeParam }));
        }
      }
    });

    this.accountService.upsControlTwoFactorStatusEmitter.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.upsControlCheckTwoFactorStatus();
    });
  
    this.accountService.upsControlAuthOtpEmitter.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      if (!this.enableUpsCtrl) {
        this.switchUpsControl(upsControlType.enableUpsControlAccess);
      } else {
        this.switchUpsControl(upsControlType.disableUpsControlAccess);
      }
    });

    this.store.select(fromStore.getAuthotp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      // console.log(res);
      if (this.allowUpsContrlAccessType !== undefined) {
        if (res.Loaded && !res.Loading) {
          if (res.entities.Flag) {
            if (res.entities.authType === AuthOtpType.TurnOn ||
              res.entities.authType === AuthOtpType.TurnOff ||
              res.entities.authType === AuthOtpType.PowerCycle) {
              this.childDialog.closeDialog();
              this.childDialog.showUpsControlAuthDialog(this.allowUpsContrlAccessType);
              this.otpid = res.entities.Id;
            }
          }
          else {
            this.childDialog.alertUpsControlCodeLock();
          }
        } else if (!res.Loaded && res.Loading) {
          if (res.entities !== undefined) {
            this.message = res.entities.Message;
          }
        }
      }
    });

    this.store.select(fromStore.getCheckAuthOtp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded && !res.Loading) {
        if (res.entities.Flag) {
          // this.apikeytype = '';
          if (this.allowUpsContrlAccessType !== '' && this.otpid !== undefined) {

            // 觸發Execute
            let upsCtrlType = 0; // (Turn Off)
            if ( res.entities.authType == AuthOtpType.TurnOn) {
              upsCtrlType = 1; // (Turn On)
            } else if (res.entities.authType == AuthOtpType.PowerCycle) {
              upsCtrlType = 2; // (Power Cycle)
            }
            const param = {
              otp: '',
              AuthType: res.entities.authType,
              AuthId: Number(this.otpid),
              dcode: this.pageContentStatus.dcode,
              ExecType : upsCtrlType
            }
            this.store.dispatch(new fromFeature.ExecuteUPSControl(param));
            this.allowUpsContrlAccessType = '';
            this.upsColudStatusParam = {
              ...this.upsColudStatusParam,
              ExecType: upsCtrlType,
              ExecStatus: 0,
            };

            this.startInterval(); // 雙因驗證過後開始跑回圈計時
            this.childDialog.closeDialog();
            this.buttonStatusFromExecType = null; // 新執行開始，清除上次的暫存值，讓執行中可正常接收 server 回傳
            this.runExecute = true;
            this.childDialog.showcloudControlProcessing();
            this.ngxService.stop();
          }
        } else {
          this.childDialog.errorMsgupsControlCode = CheckAuthOtpErrMsg[res.entities.Message];
          if (res.entities.Message === '1' || res.entities.Message === '2') {
            this.childDialog.upsControlCodeOvertime = true;
            if (res.entities.Message === '1') {
              this.childDialog.upsControlerrorMsgByLock = true;
            }
          }
          this.childDialog.upsControlCodedialogSaveDirty = true;
        }
      }
    });

    this.packageSetting();

    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getRegions),
    this.store.select(fromStore.getMspMemberAuthority)).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getRegionsRes, getMspMemberAuthorityRes]) => {
      if ((getIsMspRes !== undefined && getIsMspRes !== null) &&
          (getRegionsRes.length > 0) &&
          ((getMspMemberAuthorityRes !== null && Array.isArray(getMspMemberAuthorityRes) && getMspMemberAuthorityRes.length > 0)) ) {

        // Get isMsp
        this.isMsp = getIsMspRes;

        // Get region
        this.regionDic = {};
        getRegionsRes.map((item) => {
          this.regionDic[item.Id] = item.RegionName;
        });

        // Get Msp Member Authority For Filter Bar
        this.mspCompanyOptionsDic = {};
        this.mspMemberAuthorityDic = {};
        if (this.isMsp) {
          getMspMemberAuthorityRes.map((m) => {
            this.mspMemberAuthorityDic[m.RegionId] = m;
            if (this.regionDic[m.RegionId] !== null && this.regionDic[m.RegionId] !== undefined) {
              this.mspCompanyOptionsDic[m.RegionId] = this.regionDic[m.RegionId];
            }
          });
        }
      }
    });

    this.store.select(fromStore.getDevicesStatusState).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.isLoaded && !res.isLoading) {
        if (Object.keys(res.entities.DeviceList).length !== 0 && this.isMsp) {
          const device = res.entities.DeviceList.find(l => l.device_sn === this.sn);
          if (device !== undefined && device.RegionId !== undefined) {
            const btyRepParam = {} as BtyReplacementParams;
            const regionIds = [];
            regionIds.push(device.RegionId);
            btyRepParam.RegionIds = regionIds;
            this.store.dispatch(new fromFeature.GetBatteryReplacements(btyRepParam));
          }
        }
      }
    });

    this.store.select(fromStore.getDeviceUpsControl).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.isLoaded && !res.isLoading && res.entities !== null) {

        let hasLoadingStatus = false;
        if (Object.keys(res.entities).length !== 0) {
          this.displayUPSControl = true; // 代表權限在AccountManager & Device Manager之上, Preference EnableUpsCtrl為true
          const item = res.entities;
          this.buttonStatus = this.buttonStatusFromExecType !== null ? this.buttonStatusFromExecType : item.ButtonStatus;
          if (this.buttonStatusFromExecType !== null && item.ButtonStatus === this.buttonStatusFromExecType) {
            this.buttonStatusFromExecType = null; // server 已回傳預期值，解除鎖定
          }
          if (item.EnableCtrlOnUps == 0) { // 這台UPS 未開啟Cloud Ctrl 
            this.upsControl = false;
          } else {
            this.upsControl = true;
          }
          if (item.ExecStatus !== null) { // 代表有執行過
            if (item.ExecStatus == 0 && this.runExecute) { // Executing
              hasLoadingStatus = true;
            } else {
              if (this.runExecute) { // 判斷是否為Execute結束後 (ExecStatus: 1 Success / 2 Failure)
                this.runExecute = false;
                this.childDialog.closeDialog();
                this.childDialog.showcloudControlResult(item, this.confrimOTPParam.authType);
                if (item.ExecStatus == 1) {
                  // Execute成功後，根據執行的類型決定下一個狀態 (Turn Off -> Turn On / Turn On -> Turn Off)
                  // Output Status = Normal -> ButtonStatus = 1 ( Can Turn Off )；Output Status = No Output-> ButtonStatus = 2 ( Can Turn On )
                  this.buttonStatusFromExecType = this.upsColudStatusParam.ExecType === 0 ? 2 : 1; 
                  this.buttonStatus = this.buttonStatusFromExecType;
                  
                  //重新更新DeviceDetail狀態
                  const UserParam = {regionIds: this.RangeParam.RegionIds} as User;
                  this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
                  // this.store.dispatch(new fromStore.GetDeviceInfoAction({regionIds: this.RangeParam.RegionIds}));
                  // this.store.dispatch(new fromStore.GetDevicesDetails(this.sn));
                }
              }
            }
          }
        }
        // 計時器
        if (hasLoadingStatus) {
          this.startInterval();
        } else {
          const { ExecType: _execType, ExecStatus: _execStatus, ...rest } = this.upsColudStatusParam;
          this.upsColudStatusParam = { ...rest };
          this.stopInterval();
        }
      }
    });

  }

  ngOnInit() {
    this.ngxService.start();
    this.UI();
    this.initOutletNamingDialogInput();
    this.ngxService.stop();
  }

  changDateRange() {
    if (this.dateRange === 'all') {
      this.reportingRange = this.pageContentInfo.ReportingAll;
    } else {
      this.reportingRange = this.pageContentInfo.ReportingToday;
    }
  }

  resetField() {
    this.pageContentStatus.region = this.deviceOriginalSetting.region;
    this.pageContentStatus.deviceDescription = this.deviceOriginalSetting.deviceDescription;
    this.pageContentStatus.name = this.deviceOriginalSetting.name;
    this.batteryReplacementInfo = { ...this.deviceOriginalSetting.batteryReplacementInfo };
  }

  updateDeviceInfo() {
    if (this.pageContentStatus.region == null) {
      this.messageService.add({ severity: 'error', summary: this.translateService.instant(TRANSLATE('Please select time zone.')) });
      return;
    }
    const data: DevicesInfoData = {
      // account: '',
      timeZone: this.pageContentStatus.region,
      desc: this.pageContentStatus.deviceDescription || '',
      dcode: this.pageContentStatus.dcode,
      deviceName: this.pageContentStatus.name,
      BtyReplaceDate: this.batteryReplacementInfo.BR_Date,
      BR_Months: this.batteryReplacementInfo.BR_Months,
      isBtyReplaced: this.BtyReplaceCheck,
    };
    this.dispatchUpdateInfoAction(updateInfoType.EditDeviceInfo);
    this.pendingBRDateEpoch = this.batteryReplacementInfo.BR_Date ?? null;
    this.pendingBRDateFormat = this.batteryReplacementInfo.BR_Date_Format ?? null;
    this.store.dispatch(new fromStore.UpdateDeviceInfoAction(data));
    this.display = false;
  }

  updateDeviceInitiationDate() {
    const data: DevicesInfoData = {
      // account: '',
      timeZone: this.pageContentStatus.region,
      desc: this.pageContentStatus.deviceDescription || '',
      dcode: this.pageContentStatus.dcode,
      deviceName: this.pageContentStatus.name,
      BtyReplaceDate: this.batteryReplacementInfo.BR_Date,
      BR_Months: this.batteryReplacementInfo.BR_Months,
      isBtyReplaced: true,
      BHI_Enable: true
    };
    this.dispatchUpdateInfoAction(updateInfoType.EditDeviceInfo);
    this.pendingBRDateEpoch = this.batteryReplacementInfo.BR_Date ?? null;
    this.pendingBRDateFormat = this.batteryReplacementInfo.BR_Date_Format ?? null;
    this.store.dispatch(new fromStore.UpdateDeviceInfoAction(data));
    this.displayBHI = false;
    this.isBHIActivated = true;
    this.confirm_BHI = false;
  }

  packageSetting() {
    this.store.select(fromStore.getIsActiveUserModule, PackageList.EnergyInfo).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.energyInfoFeature = Boolean(res);
    });
    this.store.select(fromStore.getIsActiveUserModule, PackageList.BatteryTest).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.batteryTestFeature = Boolean(res);
      if (this.batteryTestFeature) {
        // Get Battery Test
        const params: BatteryTestParams = {
          upsSn: this.sn
        };
        this.store.dispatch(new fromMyfeatures.GetBatteryTestStatuss(params));
      }
    });
    this.store.select(fromStore.getIsActiveUserModule, PackageList.BatteryLife).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.batteryLife = Boolean(res);
    });
    this.readTimeOptions();
  }

  batteryTest() {
    const params: BatteryTestParams = {
      upsSn: this.sn,
      WaitingTime: this.batteryTestWaitingTime
    };
    this.store.dispatch(new fromMyfeatures.StartBatteryTest(params));
  }

  showDisplayDialog() {
    this.display = true;
    this.RBRDChange = false;
    this.BtyReplaceCheck = false;
    this.BR_Date = this.batteryReplacementInfo.BR_Date_Format;
  }

  showBHIDisplayDialog() {
    this.displayBHI = true;
    this.BR_Date = this.batteryReplacementInfo.BR_Date_Format;
  }

  showOutletNamingDisplayDialog() {
    this.outletNamingDialog = true;
  }

  initOutletNamingDialogInput() {
    this.outletNamingDialogInput = {
      outlet1: '',
      outlet2: '',
      outlet3: '',
      outlet4: '',
      outlet5: '',
      outlet6: '',
      outlet7: '',
      outlet8: '',
      outlet9: '',
      outlet10: '',
      outlet11: '',
      outlet12: '',
      outlet13: '',
      outlet14: '',
      outlet15: '',
      outlet16: '',
    };
  }

  saveOutletNaming() {
    const param = {
      otp : '',
      dcode : this.pageContentStatus.dcode,
      outlet1 : this.outletNamingDialogInput.outlet1,
      outlet2 : this.outletNamingDialogInput.outlet2,
      outlet3 : this.outletNamingDialogInput.outlet3,
      outlet4 : this.outletNamingDialogInput.outlet4,
      outlet5 : this.outletNamingDialogInput.outlet5,
      outlet6 : this.outletNamingDialogInput.outlet6,
      outlet7 : this.outletNamingDialogInput.outlet7,
      outlet8 : this.outletNamingDialogInput.outlet8,
      outlet9 : this.outletNamingDialogInput.outlet9,
      outlet10 : this.outletNamingDialogInput.outlet10,
      outlet11 : this.outletNamingDialogInput.outlet11,
      outlet12 : this.outletNamingDialogInput.outlet12,
      outlet13 : this.outletNamingDialogInput.outlet13,
      outlet14 : this.outletNamingDialogInput.outlet14,
      outlet15 : this.outletNamingDialogInput.outlet15,
      outlet16 : this.outletNamingDialogInput.outlet16
    };
    this.store.dispatch(new fromFeature.UpdateDeviceSetting(param));
    this.outletNamingDialog = false;
  }

  checkBtyReplace(event) {
    // PrimeNG 20 Checkbox onChange 傳入 CheckboxChangeEvent
    const checked = typeof event === 'boolean' ? event : !!event?.checked;
    this.BtyReplaceCheck = checked;
    if (checked) {
      this.childDialog.btyReplaceCheck();
    }
  }

  changeBtyReplacementDate(event) {
    if (!event) {
      this.batteryReplacementInfo.BR_Date_Format = null;
      this.batteryReplacementInfo.BR_Date = null;
      this.batteryReplacementInfo.BR_Rc_Date = null;
      this.RBRDChange = true;
      this.BtyReplaceCheck = false;
      return;
    }
    this.batteryReplacementInfo.BR_Date_Format = (event != null) ?
      new Date(((event.getTime())) - (this.localTimeZone * 60 * 60 * 1000)) : null;
    this.batteryReplacementInfo.BR_Date = (event != null) ?
      ((event.getTime()) / 1000) - (this.localTimeZone * 60 * 60) : null;
    const dt = new Date(event.getTime());
    dt.setMonth(event.getMonth() + this.batteryReplacementInfo.BR_Months);
    this.batteryReplacementInfo.BR_Rc_Date = dt.getTime();

    if (this.BR_Date && this.BR_Date.getTime && this.BR_Date.getTime() === event.getTime()) {
      this.RBRDChange = false;
      this.BtyReplaceCheck = false;
    } else {
      this.RBRDChange = true;
    }
  }

  changeBatteryLife(event) {
    if (!this.batteryReplacementInfo?.BR_Date_Format || event == null) {
      return;
    }
    const dt = new Date(this.batteryReplacementInfo.BR_Date_Format.getTime());
    dt.setMonth(this.batteryReplacementInfo.BR_Date_Format.getMonth() + event);

    // changed the battery life, so adjust battery rc date.
    this.batteryReplacementInfo.BR_Rc_Date = dt.getTime();
  }

  readTimeOptions() {
    this.timeOptions = [
      { label: this.translateService.instant('Instant'), value: 0 },
      { label: ('1 ' + this.translateService.instant('min')), value: 1 },
      { label: ('2 ' + this.translateService.instant('min')), value: 2 },
      { label: ('3 ' + this.translateService.instant('min')), value: 3 },
      { label: ('4 ' + this.translateService.instant('min')), value: 4 },
      { label: ('5 ' + this.translateService.instant('min')), value: 5 },
      { label: ('6 ' + this.translateService.instant('min')), value: 6 },
      { label: ('7 ' + this.translateService.instant('min')), value: 7 },
      { label: ('8 ' + this.translateService.instant('min')), value: 8 },
      { label: ('9 ' + this.translateService.instant('min')), value: 9 },
      { label: ('10 ' + this.translateService.instant('min')), value: 10 },
    ];
  }

  onTabChange(e) {
    this.indexNum = e.index;
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    // body.classList.remove('layout-toggle');
    body.classList.remove('mobile-toggle');
    body.classList.remove('events');
  }

  goBack(): void {
    this.location.back();
  }

  displayMspAuth_fun() {
    if (this.isMsp && (Object.keys(this.mspCompanyOptionsDic).length > 0 || this.mspSelectedRegionId.length > 0)) {
      this.mspCompanyOptions = [];
      if (this.mspMemberAuthorityDic[this.device_regionId] !== undefined &&
         this.mspMemberAuthorityDic[this.device_regionId].ViewDevice === 1) {
        if (this.mspMemberAuthorityDic[this.device_regionId].EditDevice !== 1) {
          this.disableOutletSave = true;
          this.disableBHI = true;
          this.disableBattery = true;
          this.disableSetting = true;
        }
      }
    }
  }

  showAlertCloudControlDisabledDisplayDialog() {
    this.childDialog.cloudControlDisabled();
  }

  showCloudControlTurnOffDialog() {
    this.childDialog.cloudControlTurnOffDialog();
  }

  showCloudControlTurnOnDialog() {
    this.childDialog.cloudControlTurnOnDialog();
  }

  upsControlCheckTwoFactorStatus() {
    const isChecked = this.twoFactorAuthentication;
    if (isChecked !== true) {
      this.childDialog.alertUpsControlTwoFactorEnable();
    } else {
      this.accountService.upsControlAuthOtpEvent();
    }
  }

  switchUpsControl(result: string) {

    if (!this.twoFactorAuthentication) {
      this.childDialog.alertUpsControlTwoFactorEnable();
      return;
    }

    let authState = AuthOtpType.TurnOn; // default

    switch (result) {
      case upsControlType.turnOn:
        authState = AuthOtpType.TurnOn;
        break;
      case upsControlType.turnOff:
        authState = AuthOtpType.TurnOff;
        break;
      case upsControlType.powerCycle:
        authState = AuthOtpType.PowerCycle;
        break;
      default:
        return;
    }

    this.allowUpsContrlAccessType = result;
    this.childDialog.errorMsgAPICode = "";

    this.confrimOTPParam = { ...this.confrimOTPParam, authType: authState };

    const param = {
      otp: "",
      DeviceType: AuthOtpDeviceType.Web,
      AuthType: authState,
    };

    this.store.dispatch(new fromFeature.AddAuthOtp(param));
  }

  confrimUpsControlCode(result: string) {
    if (
      result === upsControlType.turnOn ||
      result === upsControlType.turnOff ||
      result === upsControlType.powerCycle) {
      let authtype = 0
      if (result.toLowerCase() === upsControlType.turnOn.toLowerCase()) {
        authtype = AuthOtpType.TurnOn;
      } else if (result.toLowerCase() === upsControlType.turnOff.toLowerCase()) {
        authtype = AuthOtpType.TurnOff;
      } else if (result.toLowerCase() === upsControlType.powerCycle.toLowerCase()) {
        authtype = AuthOtpType.PowerCycle;
      }
      const param = {
        otp: '',
        authId: Number(this.otpid),
        authOtp: this.accountService.GetAuthOtp,
        authType: authtype,
      };
      this.store.dispatch(new fromFeature.CheckAuthOtp(param));
    }
  }

  reloadUpsControl() {
    this.store.dispatch(new fromMyfeatures.GetUPSControlStatus({ ...this.upsColudStatusParam }));
  }
  
  startInterval() {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        this.reloadUpsControl();
      }, ReLoadDeviceUpsControlSec * 1000);
      // console.log("計時器已啟動");
    }
  }

  stopInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      // console.log("計時器已停止");
    }
    this.intervalCnt = 0;
  }

  private dispatchUpdateInfoAction(type: string): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromMyfeatures.UpdateInfoAction({ ...this.UpdateInfoParam }));
  }

  ngOnDestroy() {
    this.btyTimeCycling = null;
    this.stopInterval();
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
